import styled from 'styled-components';
import { IonMenu } from '@ionic/react';

export const IonMenuWrapper = styled(IonMenu)`
  .app-copyright {
    font-size: 0.8rem;
    color: var(--ion-color-medium);
    position: absolute;
    bottom: 0;
    margin-bottom: 1rem;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;